import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

export const handleCreateBooking = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/member/booking/create`
      },
      thunkAPI
    )
  }
)

